import { Tab, TabProps, styled } from '@mui/material';

interface CustomTabProps extends TabProps {
  selected?: boolean;
}

export const CustomTab = styled((props: CustomTabProps) => <Tab {...props} />)(({ theme, selected }) => ({
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: selected ? 700 : 400,
  lineHeight: '28px',
  letterSpacing: '0.15px',
}));
